export default __webpack_public_path__ + "static/media/Vector1.f23575d7.svg";